import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from 'src/app/services/translate.service';
import { trackByIndex } from 'src/app/shared/utils/track-by.util';

interface StarterPrompt {
  icon: string;
  label: string;
}

const STARTER_PROMPTS: StarterPrompt[] = [
  { icon: 'trending_up', label: 'Which SEGs are trending toward the OEL?' },
  { icon: 'warning_amber', label: 'How many exceedances did we have last month?' },
  { icon: 'show_chart', label: 'Show our quarterly exceedance counts for the last 3 years as a chart' },
  { icon: 'monitor_heart', label: 'Which sensor parameters are we monitoring?' },
];

@Component({
  standalone: false,
  selector: 'app-chat-empty-state',
  templateUrl: './chat-empty-state.component.html',
  styleUrls: ['./chat-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatEmptyStateComponent {
  @Output() promptSelected = new EventEmitter<string>();

  readonly prompts = STARTER_PROMPTS;
  readonly trackByIndex = trackByIndex;

  constructor(private readonly translateService: TranslateService) {}

  onPromptClick(label: string): void {
    this.promptSelected.emit(this.translateService.getDynamicTranslation(label));
  }
}
